import { render, staticRenderFns } from "./IconAutoAdd.vue?vue&type=template&id=0a543f9c&"
import script from "./IconAutoAdd.vue?vue&type=script&lang=js&"
export * from "./IconAutoAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a543f9c')) {
      api.createRecord('0a543f9c', component.options)
    } else {
      api.reload('0a543f9c', component.options)
    }
    module.hot.accept("./IconAutoAdd.vue?vue&type=template&id=0a543f9c&", function () {
      api.rerender('0a543f9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconAutoAdd.vue"
export default component.exports